<script lang="ts" setup>
import { formatMessageTime } from '../../utils';

interface Props {
  time: number;
}

const props = defineProps<Props>();
</script>

<template>
  <div class="text-colorTextTertiary mb-3 text-center text-sm leading-[22px]">
    {{ formatMessageTime(props.time, true) }}
  </div>
</template>
<style scoped></style>
